import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import {
  LayersControl,
  MapContainer,
  Popup,
  TileLayer,
  useMapEvents,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";

import { useMapStore } from "../store/mapStore";
import DronesMapViewLayer from "../pages/drones/dronesMapView";
import MissionMapViewLayer from "../pages/mission/missionMapView";
import { useLocation } from "react-router-dom";
import ZonesMapView from "../pages/zonesMapView";
import DroneDetailsMapView from "../pages/drones/droneDetailsMapView";
import FlightDetailsMapView from "../pages/flights/flightsMapView";
import Legend from "./legends/legends";
import MissionWaypointMapView from "../pages/mission/missionWaypointMapView";

const MapView = () => {
  const mapRef = useRef(null)
  const [mapCenter, setMapCenter] = useState([26.2141389, 78.120858])
  const [position, setPosition] = useState(null);
  const location = useLocation();
  const pathName = location.pathname.split("dashboard")[1]
  const { storeWaypoints } = useMapStore((state) => state)
  useEffect(() => {
    if (storeWaypoints?.length > 0) {
      setMapCenter(storeWaypoints?.length > 0 && [storeWaypoints[0]?.lat, storeWaypoints[0]?.lng])
    }
  }, [storeWaypoints])

  function handleClick(e) {
    setPosition(e.latlng);
  }
  function LocationMarker() {
    useMapEvents({
      click(e) {
        handleClick(e);
      },
    });

    return position === null ? null : (

      <Popup position={position}>
        {position.lat.toFixed(6)}, {position.lng.toFixed(6)}
      </Popup>

    );
  }

  return (
    <div className="z-10 opacity-80">
      <MapContainer
        ref={mapRef}
        center={mapCenter}
        zoom={6}
        key={mapCenter}
        scrollWheelZoom={true}
        className="h-full w-full"
        style={{ width: "100%" }}
      >
        <TileLayer
          attribution='Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery &copy; <a href="https://www.mapbox.com/">Mapbox</a>'
          url="https://api.mapbox.com/styles/v1/avi047/clggjhx5o003m01pe8j4x27a4/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiYXZpMDQ3IiwiYSI6ImNsZzB1ZzViMjAwcG8zb2wyZGRjeWVlenkifQ.mSYEYtyu4CGsYyJU7jiXfw"
        />
        <LayersControl position='topright'>
          <Legend />
          <ZonesMapView />
          {pathName === "/" && <DronesMapViewLayer />}
          {pathName.includes("/mission") && <MissionWaypointMapView />}
          {pathName.includes("/mission-details/") && <MissionMapViewLayer />}
          {pathName.includes("/drone-details/") && <DroneDetailsMapView />}
          {pathName.includes("/flight-details/") && <FlightDetailsMapView />}
          {pathName.includes("/flights") && <MissionMapViewLayer />}
        </LayersControl>
        <LocationMarker />
      </MapContainer>
    </div>
  );
};

export default MapView;
